export const ACTION_TYPE_ENUM = {
  RESPONSE: "Đáp ứng giả định hoạt động liên tục",
  NOT_RESPONSE: "Không đáp ứng giả định hoạt động liên tục",
};
